import { render } from "./IconUser.vue?vue&type=template&id=5a1b180f"
import script from "./IconUser.vue?vue&type=script&lang=ts"
export * from "./IconUser.vue?vue&type=script&lang=ts"
script.render = render

export default script